<template>
  <div 
    @scroll="continuesscroll"
    class="deliveriesListunassignedDesktop">
        <template v-for="(group, index) in ordergroup">

            <div 
                v-if="checkifhastoassign(group) && group.date != 'pastdue'"
                :key="group.date+'delivery'" class="deliveries">
                <b-container>
                    <div 
                        v-if="['xs','sm','md'].includes(windowsize.breakpoint)"
                        class="mobilecomponent">
                         <h3>{{group.date | formatreldate}}</h3>

                          <template v-for="order in group.orders">
                              
                            <unassignedlistmobile 
                                :key="order.id" 
                                :pastduelist="pastduelist"
                                :assignorder.sync="assignorder"
                                :showAssignPop.sync="showAssignPop"
                                :assignedorderids="assignedorderids"
                                :group="group"
                                :order="order" />
                        
                        </template>
                    </div>

                    <table 
                        v-if="['lg','xl','xxl'].includes(windowsize.breakpoint)"
                        class="table desktoporderlisttable">
                        <thead >
                            <tr class="dategrouplabel">
                                <th colspan="6">
                                    <h3>{{group.date | formatreldate}}</h3>
                                </th>
                            </tr>

                            <tr 
                                v-if="index == 0"
                                class="tableheaderlabels">
                                <th>
                                    QTY
                                </th>

                                <th>
                                    NAME
                                </th>

                                <th>
                                    PHONE
                                </th>

                                <th>
                                    DELIVERY TIME
                                </th>

                                <th>
                                    ADDRESS
                                </th>

                                <th>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <template v-for="order in group.orders">
                                <unassignedlistdesktop 
                                    :key="order.id" 
                                    :assignorder.sync="assignorder"
                                    :showAssignPop.sync="showAssignPop"
                                    :assignedorderids="assignedorderids"
                                    :group="group"
                                    :order="order" />

                                <tr :key="order.id+'space'" class="space">
                                    <td colspan="6"></td>
                                </tr>
                            
                            </template>
                        </tbody>
                        
                    </table>

                </b-container>
            </div>

            <div 
                v-if="checkifhastoassign(group) && group.date == 'pastdue'"
                :key="group.date+'delivery'" class="deliveries">
                <b-container>
                    <div 
                        v-if="['xs','sm','md'].includes(windowsize.breakpoint)"
                        class="mobilecomponent">
                         <h3>Past Due</h3>

                          <template v-for="order in group.orders">
                              
                            <unassignedlistmobile 
                                :key="order.id" 
                                :assignorder.sync="assignorder"
                                :showAssignPop.sync="showAssignPop"
                                :assignedorderids="assignedorderids"
                                :group="group"
                                :order="order" />
                        
                        </template>
                    </div>

                    <table 
                        v-if="['lg','xl','xxl'].includes(windowsize.breakpoint)"
                        class="table desktoporderlisttable">
                        <thead >
                            <tr class="dategrouplabel">
                                <th colspan="6">
                                    <h3>Past Due</h3>
                                </th>
                            </tr>

                            <tr 
                                v-if="index == 0"
                                class="tableheaderlabels">
                                <th>
                                    QTY
                                </th>

                                <th>
                                    NAME
                                </th>

                                <th>
                                    PHONE
                                </th>

                                <th>
                                    DELIVERY TIME
                                </th>

                                <th>
                                    ADDRESS
                                </th>

                                <th>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <template v-for="order in group.orders">
                                <unassignedlistdesktop 
                                    :key="order.id" 
                                    :assignorder.sync="assignorder"
                                    :showAssignPop.sync="showAssignPop"
                                    :assignedorderids="assignedorderids"
                                    :group="group"
                                    :order="order" />

                                <tr 
                                    v-if="!assignedorderids.includes(order.id)"
                                    :key="order.id+'space'" class="space">
                                    <td colspan="6"></td>
                                </tr>
                            
                            </template>
                        </tbody>
                        
                    </table>

                </b-container>
            </div>
        </template>



        <assign-pop 
            :order.sync="assignorder"
            @update="updateunassignlist"
            @close="() => {showAssignPop = false}"
            v-show="showAssignPop" />

  </div>
</template>

<script>

// plugins 
import _ from 'lodash'

// components
import assignPop from '@/components/admin/assigningList.vue'
import unassignedlistmobile from '@/components/admin/unassignedlistmobile'
import unassignedlistdesktop from '@/components/admin/unassignedlistdesktop'

//Mixins
import {mapMixins} from '@/mixins/mapMixins'
import {ordermixins} from '@/mixins/ordermixins'

// Helpers
import Helper from '@/helpers/helper.js'
import {getCollections, newJob, addUpdateCollection, cleanrecord} from '@/helpers/localbase'
import axios from 'axios'
import moment from 'moment'

export default {
    mixins    : [mapMixins, ordermixins],
    components: {
        'assign-pop'           : assignPop,
        'unassignedlistmobile' : unassignedlistmobile,
        'unassignedlistdesktop': unassignedlistdesktop
    },
    props : {
        assignedorders : {
            type   : Array,
            default: () => []
        }
    },
    data() {
        return {
            showAssignPop   : false,
            ordergroup      : [],
            assignorder     : null,
            unassignedorders: [],
            currentpage     : 1,
            maxpage         : 1,
            fetching        : true,
            pastduelist     : []
        }
    },
    computed : {
        /**
         * Windows size
         */
        windowsize() {
            return this.$store.state.windowsize
        },
        /**
         * Assigned order ids
         */
        assignedorderids() {
            return this.assignedorders.map(o => o.id)
        },
        /**
         * Socketio / webhook connection
         */
        socketio() {
            return this.$store.state.socketio
        },
        /**
         * Network status
         */
        isonline() {
            return this.$store.state.isonline
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        }
    },
    methods : {
        /**
         * Check if skiped deliveries
         */
        checkifskip(order) {
            // Flat skiped deliveries array since the return data is nested array
            const skipeddates =  _.flatten(order.orderskipdeliveries).map(s => Helper.formatdate(s.skip_date, 'MM/DD/YYYY', true))
            const ddate = Helper.formatdate(order.delivery_date, 'MM/DD/YYYY')

            console.log('skip deliveries', skipeddates, ddate)
            

            return skipeddates.includes(ddate) ? false : true
        },
       
        /**
         * Continues scroll 
         * fetch unassign list pages when scrolling
         */
        continuesscroll() {
            if(!this.fetching) {
                if(this.maxpage >= this.currentpage) {
                    this.getunassignedorders(true)
                }
            }
        } ,
        /**
         * Check if group order has to assign order
         */
        checkifhastoassign(group) {
            const orders = group.orders.filter(o => !this.assignedorderids.includes(o.id))

            return orders.length > 0 ? true : false
        },
        /**
         * Update unassignedlist
         * remove assigned order to unassignlist
         */
        updateunassignlist(orderid) {
            this.unassignedorders = this.unassignedorders.filter(order => order.id != orderid)

            /**
             * Insert past due orders
             */
            let group = this.grouporderbydates(this.unassignedorders);
            if(group.length >= 2) {
                 group.splice(2,0, {
                    date  : 'pastdue',
                    orders: this.pastduelist
                })
            }

            this.ordergroup = group
            
            this.$emit('update', 'orderlist')
        },
        /**
         * Get unassligned list
         * Pull from indexed db first
         */
         getunassignedorders : _.debounce( async function (page = false) {
                  this.fetching         = true
            const ilist                 = await getCollections({name : 'unassignedorders'})
                  this.unassignedorders = ilist;


            /**
             * Api request
             */
            const url = page ? `/all_unassigned_orders?page=${this.currentpage + 1}` :  '/all_unassigned_orders'
            const res = await axios.get(url).catch(err => console.log(err))

            /**
             * checking if fetching next page
             * if not reset order list for clean up
             */

            if(!page) {
                this.unassignedorders = []
            }

            if(res.data) {
                /**
                 * Get past due date orders
                 */

                this.pastduelist = [...this.pastduelist, ...res.data.data.filter(order => moment(Helper.formatdate(order.delivery_date, 'MM/DD/YYYY')).isBefore(Helper.formatdate(moment(), 'MM/DD/YYYY', true)))]

                /**
                 * Get unassign incoming orders
                 */
                let newdata          = [...this.unassignedorders, ...res.data.data].filter((item, index, array) => index == array.findIndex(t => t.id === item.id))
                    this.maxpage     = res.data.last_page
                    this.currentpage = res.data.current_page
                /**
                 * Set local state
                 * and update indexed db
                 * remove order that are skipped
                 */

                this.unassignedorders = newdata.filter(o => this.checkifskip(o))

                newdata.forEach(d => {
                    addUpdateCollection({name : 'unassignedorders', data : d})
                })

                console.table('unassigned list')
                console.table(this.unassignedorders )

                /**
                 * Clean trash records
                 */
                cleanrecord(newdata, ilist, 'id', 'unassignedorders')

            } else if(!this.isonline) {
                /**
                 * If offline add request to job
                 */

                newJob({
                    url   : url,
                    method: "GET",
                    callback : async (data, options) => {
                        if(data) {
                            let newdata  = data.data
                            /**
                             * Set local state
                             * and update indexed db
                             */

                            newdata.forEach(d => {
                                options.db.addUpdateCollection({name : 'unassignedorders', data : d})
                            })

               
                        }
                    }
                })
            }

            // Group orders
            this.fetching   = false

            /**
             * Insert past due orders
             */
            let group = this.grouporderbydates(this.unassignedorders);
            group.unshift({
                date  : 'pastdue',
                orders: this.pastduelist
            })

            // if(group.length >= 2) {
            //      group.splice(2,0, {
            //         date  : 'pastdue',
            //         orders: this.pastduelist
            //     })
            // } else {
            //     group = [...group, {
            //         date  : 'pastdue',
            //         orders: this.pastduelist
            //     }]
            // }

            this.ordergroup = group



        }, 500),
        /**
         * Socket / webhook listener
         */
        async socketiolisten() {

            // check if socket io defined
            if(!this.socketio) return;

            console.log('init broadcast listener')

            //listen to broadcast
            this.socketio.on('broadcast', async data => {
                console.log('broadcast', data)

                if(data) {
                    switch (data.type) {
                        case 'neworder':
                                await this.getunassignedorders();
                                // get unread notif
                                this.$store.dispatch('getunreadnotifs')
                            break;

                        case 'rejectassigned':
                                await this.getunassignedorders();
                                this.$emit('update', 'orderlist');
                                // get unread notif
                                this.$store.dispatch('getunreadnotifs')
                            break;

                        case 'acceptedassign':
                                // await this.getunassignedorders();
                                this.$emit('update', 'orderlist');
                                // get unread notif
                                this.$store.dispatch('getunreadnotifs')
                            break;

                        case 'orderdlivered':
                                await this.getunassignedorders();
                                this.$emit('update', 'orderlist');
                                // get unread notif
                                this.$store.dispatch('getunreadnotifs')
                            break;

                        case 'amedorder':
                            console.log('new amend note', data)
                                if(data.updateto == 'manager') {
                                    this.$emit('update', 'orderlist');
                                    // get unread notif
                                    this.$store.dispatch('getunreadnotifs')
                                }
                            break;
                    
                        default:
                            break;
                    }
                }
            })
            
        }
    },
    /**
     * Run function before component render 
     */
    async beforeMount() {
        // Google map
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
        });

        /**
         * unassigned list
         */
        await this.getunassignedorders();

        
    },
    /**
     * Run function after component render
     */
    mounted() {
      // socket io listner 
      this.socketiolisten()
    }

}
</script>

<style lang='scss'>
@import '@/scss/partials/_mixins.scss';
@import '@/scss/partials/_colors.scss';

.deliveriesListunassignedDesktop {
    // max-height: 87vh;
    // overflow  : hidden auto;

    .deliveries {
        border-bottom: 10px solid $lightgrey;
        padding      : 15px 0 0;
        min-height   : 200px;
        

        h3 {
            color        : $primaryColor;
            font-size    : 15px;
            font-weight  : 700;
            margin-bottom: 0;
        }
        
        .deliveryItem {
            border-bottom : 1px solid $lightgrey2;
            padding-bottom: 15px;
            padding-top   : 15px;

            &.notactive {
                opacity       : .5;
                pointer-events: none !important;
            }

            &:last-child {
                border-color : transparent;
            }

            .googleMap {
                * {
                    pointer-events: none;
                }
            }

            .vue-map-container {
                min-height: 60px;;
                height    : 100%;
            }

            .OrderInfo {
                display: flex;
    
                .itemSize  {
                    width           : 60px;
                    height          : 60px;
                    border-radius   : 100%;
                    display         : flex;
                    flex-direction  : column;
                    align-items     : center;
                    justify-content : center;
                    background-color: $lightgrey;
                    margin-right    : 15px;
    
                    span {
                        display    : block;
                        font-weight: 800;
    
                        &:last-child {
                            font-size : 10px;
                        }
                    }
                }

                .orderName {
                    margin-bottom : 0;
                    
                    h2 {
                        font-size    : 20px;
                        font-weight  : 700;
                        margin-bottom: 0;
                    }
    
                    p {
                        color        : $grey;
                        margin-bottom: 0;
                    }
                }
                
            }

            .deliverAssign {
                font-size      : 30px;
                display        : flex;
                justify-content: flex-end;
                cursor         : pointer;
            }

            .deliveryInfo {
                color     : $grey;
                margin-top: 10px;


                .deliveryDateandTime {
                    font-size   : 15px;
                    padding-left: 10px;

                    .ddate {
                        margin-bottom : 8px;
                    }

                    .dAddress {
                        display: flex;

                        svg {
                            position    : relative;
                            top         : 2px;
                            margin-right: 5px;
                        }
                    }
                }
            }
        }
    }

    .desktoporderlisttable {

        td, th {
            border        : none;
            vertical-align: middle;
        }

        .tableheaderlabels {
            th {
                font-size  : 15px;
                font-weight: 700;

                &:first-child {
                    padding-left : 70px;
                }
            }
        }

        tbody {
            tr {
                background-color: #fff;
                // border : 2px solid transparent;

                &.space {
                    background-color: transparent;
                    td {
                        padding : 5px 0;
                    }
                }

                &.assigningorder {
                    border : 2px solid $primaryColor;
                }

                td {

                    .bi-circle {
                        color : $lightgrey2;
                    }

                    &:first-child {
                        padding-left : 70px;
                    }

                    &:nth-child(3), &:nth-child(4) {
                        white-space: nowrap;
                    }

                }
                
            }
        }
    }

}
</style>